import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addReaction } from '../../../services/Trainer/trainer';
import { toast } from 'react-toastify';
import Appreciate from '../../../assets/policy/appreciate-icon.png'
import Insight from '../../../assets/policy/insight-icon.png'
import Like from '../../../assets/policy/like-icon.png'
import Love from '../../../assets/policy/love-icon.png'
import { useAuth } from '../../../context/AuthContext';
import moment from 'moment';
import { renderDescriptionHtml } from '../../../components/common/renderDescriptionHtml';

const users = [
  {
    id: 1,
    name: "Emma Grace",
    time: "2nd",
    designation: "Designations",
    // avatar: "/placeholder.svg?height=60&width=60",
    badgeType: "primary",
    category: "like", // 👍
  },
  {
    id: 2,
    name: "William Henry",
    time: "2nd",
    designation: "Designations",
    // avatar: "/placeholder.svg?height=60&width=60",
    badgeType: "primary",
    category: "like", // 👍
  },
  {
    id: 3,
    name: "Amelia Jane",
    time: "2nd",
    designation: "Designations",
    // avatar: "/placeholder.svg?height=60&width=60",
    badgeType: "danger",
    category: "love", // ❤️
  },
  {
    id: 4,
    name: "Ava Skye",
    time: "2nd",
    designation: "Designations",
    // avatar: "/placeholder.svg?height=60&width=60",
    badgeType: "success",
    category: "appreciate", // 😊
  },
  {
    id: 5,
    name: "Luna Raine",
    time: "2nd",
    designation: "Designations",
    // avatar: "/placeholder.svg?height=60&width=60",
    badgeType: "warning",
    category: "insightful", // 💡
  },
];

const PostCard = ({ post, feeds, setFeeds }) => {
  // Function to get user initials for profile picture fallback
    const { user } = useAuth()
  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : 'U';
  };
  const [activeFilter, setActiveFilter] = useState("all")
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  // Function to get post type specific styling
  const getPostTypeColor = (type) => {
    switch (type) {
      case 'policy':
        return 'text-primary';
      case 'news':
        return 'text-success';
      case 'announcement':
        return 'text-info';
      default:
        return 'text-secondary';
    }
  };
  const filterCounts = {
    all: 30,
    purple: 8,
    green: 10,
    orange: 12,
    heart: 12,
  }

  const filteredUsers = activeFilter === "all" ? users : users.filter((user) => user.category === activeFilter)

  const handleReaction = async (reactionType) => {
    // Determine if the clicked reaction is already selected
    const isSameReaction = post?.reaction === reactionType;
const previousReaction = post?.reaction;
    // Toggle logic: set to empty if same, otherwise update
    const newReaction = isSameReaction ? '' : reactionType;

    const payload = {
      feedId: post?._id,
      reaction: reactionType,
    };
    // setFeeds((prevFeeds) =>
    //   prevFeeds.map((feed) =>
    //     feed._id === post._id
    //       ? { ...feed, reaction: newReaction }
    //       : feed
    //   )
    // );
    setFeeds((prevFeeds) =>
    prevFeeds.map((feed) => {
      if (feed._id !== post._id) return feed;

      const updatedFeed = { ...feed };

      // Decrease previous reaction count if it exists and reaction is changing or being removed
      if (previousReaction && previousReaction !== '' && previousReaction !== newReaction) {
        const prevKey = `total_${previousReaction}`;
        if (updatedFeed[prevKey] > 0) updatedFeed[prevKey] -= 1;
      }

      // Increase new reaction count if it's a different one
      if (!isSameReaction && newReaction) {
        const newKey = `total_${newReaction}`;
        updatedFeed[newKey] = (updatedFeed[newKey] || 0) + 1;
      }

      // Update the reaction field
      updatedFeed.reaction = newReaction;
      console.log("updatedfeed",updatedFeed)
      return updatedFeed;
    })
  )
    try {
      setLoading(true);
      const result = await addReaction(payload);
      console.log('Reaction updated:', result);

      if (result?.success) {
        // toast.success(result?.message);

        // Update the local post state

      } else {
        // toast.error(result?.message);
      }
    } catch (err) {
      console.error('Failed to update reaction:', err);
      toast.error('Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  // Default policy image placeholder
  const defaultPolicyImage = '/placeholder.svg?height=200&width=400';
const getProcessedDescription = (post) => {
  let html = post.description || "";

  // Replace placeholders (image_1, image_2) with actual URLs
  if (Array.isArray(post.images)) {
    post.images.forEach((url, index) => {
      const placeholder = `image_${index + 1}`;
      const fullUrl = `${process.env.REACT_APP_BUCKET_URL}${url}`;
      html = html.replaceAll(placeholder, fullUrl);
    });
  }

  // Convert containerstyle/wrapperstyle → style
  html = html.replaceAll("containerstyle=", "style=");
  html = html.replaceAll("wrapperstyle=", "style=");

  return html;
};
  return (
    <>


      <div className="card mb-4 shadow-sm border-0" style={{ borderRadius: '12px' }}>
        <div className="card-body p-4">
          {/* Header Section */}
          <div className="d-flex align-items-start mb-3">
            <div className="me-3">
              {post?.addedBy?.profileImageUrl ? (
                <img
                  src={`${process.env.REACT_APP_BUCKET_URL}${post?.addedBy?.profileImageUrl}`}
                  alt={post?.addedBy?.fullName || 'User'}
                  className="rounded-circle"
                  style={{ width: '48px', height: '48px', objectFit: 'cover' }}
                />
              ) : (
                <div
                  className="rounded-circle bg-light d-flex align-items-center justify-content-center text-muted fw-bold"
                  style={{ width: '48px', height: '48px', fontSize: '18px' }}
                >
                  {getInitials(post?.addedBy?.fullName)}
                </div>
              )}
            </div>
            <div className="flex-grow-1">
              <h5 className="card-title mb-1 fw-bold">{post.title}</h5>
              {/* <span className={`badge ${getPostTypeColor(post.type)} bg-opacity-10 text-capitalize`}> */}
              <span className={`  text-capitalize`} style={{color:'#252525',fontWeight:'400'}}>
                {post.type}
              </span>
              <p style={{color:'#252525',fontWeight:'400',fontSize:'10px'}}>{moment(post?.createdAt).fromNow()}</p>
            </div>
          </div>
          {/* <button className="btn btn-primary mt-3" onClick={() => setShowModal(true)}>
          Open User Modal
        </button> */}
          {/* Description */}
           {/* {
            post.type !== "policy" && post.description &&
            <>
            {post.description}
            
            </>
           } */}
          {
            // post.type === "policy" &&
            <>
            {
          
          post.description && (
            <div
              className="card-text text-muted mb-3"
              style={{
                // display: '-webkit-box',
                // WebkitLineClamp: 3,
                // WebkitBoxOrient: 'vertical',
                // overflow: 'hidden',
                // textOverflow: 'ellipsis',
                // lineHeight: '1.6'
              }}
            >
              {/* <div dangerouslySetInnerHTML={{ __html: post.description }} /> */}
               <div
                  className="post-description"
                  dangerouslySetInnerHTML={{ __html: renderDescriptionHtml(post) }}
                />
            </div>
          )}

          <button
            onClick={() =>
              { 
                if(post?.type == "announcement"){
                navigate(`${post._id}`)
                }
                else if (post?.type == "policy"){
                navigate(`${post._id}`)
                }
                else{
                navigate(`${post._id}`)
                }
              }}
            // className="btn btn-link p-0 mt-2"
            style={{ fontSize: '0.9rem' }}
          >
            Read More
          </button>
            </>
          }
          

          {/* Image Section */}
          {(post.type === 'news' || post.type === 'announcement') && post.image && (
            <div className="my-2 mb-3" style={{height:'350px',backgroundColor:'black'}}>
              <img
                // src={post.image || "/placeholder.svg"}
                src={`${process.env.REACT_APP_BUCKET_URL}${post?.image}`}
                alt={post.title}
                className="img-fluid rounded"
                style={{ width: '100%',height:'100%', objectFit: 'contain' }}
              />
            </div>
          )}

          {/* Policy Image */}
          {post.type === 'policy' && (
            <div className=" d-flex justify-content-center align-items-center  bg-light mb-3">
              <div
                className="card border-0 shadow-sm p-5 text-center"
                style={{
                  backgroundColor: "#E8E2D5",
                  // maxWidth: "400px",
                  height: '100%',
                  width: "100%",
                }}
              >
                {/* FB Logo */}
                <div className="mb-3">
                  <h1
                    className="display-4 mb-0"
                    style={{
                      fontFamily: "serif",
                      fontWeight: "300",
                      color: "#333",
                      letterSpacing: "2px",
                    }}
                  >
                    EB
                  </h1>
                </div>

                {/* Empowering Beauty */}
                <p
                  className="text-muted mb-2"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    letterSpacing: "1px",
                  }}
                >
                  Empowering Beauty
                </p>

                {/* Policy Update */}
                <h2
                  className="h4 mb-3"
                  style={{
                    fontWeight: "bold",
                    color: "#333",
                    fontSize: "24px",
                  }}
                >
                  Policy Update
                </h2>

                {/* Description */}
                <p
                  className="text-muted mb-0"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  Please Check out our new policy
                </p>
              </div>
            </div>
          )}

          {/* Engagement Section */}
          {/* {post.engagementCount && ( */}
{
  console.log("postSDFSADF",post)
}
          {(post.othersReactionsTotal > 0 || post.reaction) &&(
                      <div className="d-flex align-items-center mb-3">
                        <div className="d-flex me-2"  onClick={() => setShowModal(true)} style={{cursor:'pointer'}}>
                          {/* Sample engagement avatars */}
                          {
                            post.total_appreciate > 0 &&
                            <img
                            src={Appreciate}
                            alt="User"
                            className="rounded-circle border border-white"
                            style={{ width: '24px', height: '24px', marginLeft: '-4px' }}
                          />
                          }
                          {
                            post.total_insightful > 0 &&
                            <img
                            src={Insight}
                            alt="User"
                            className="rounded-circle border border-white"
                            style={{ width: '24px', height: '24px', marginLeft: '-10px' }}
                          />
                          }
                          
                          {
                            post.total_like > 0 &&
                             <img
                            src={Like}
                            alt="User"
                            className="rounded-circle border border-white"
                            style={{ width: '24px', height: '24px', marginLeft: '-10px' }}
                          />
                          }
                          
                            {
                            post.total_love > 0 &&
                           <img
                            src={Love}
                            alt="User"
                            className="rounded-circle border border-white"
                            style={{ width: '24px', height: '24px', marginLeft: '-10px' }}
                          />
                          }
                        </div>
                         <small className="text-muted" onClick={() => setShowModal(true)} style={{cursor:'pointer'}}>
                          {
                            post.reaction ?
                              <>
                               You {post.othersReactionsTotal > 0 ? <> {`${post.othersReactionsTotal} and others`} </> :""} 
                              </>
                            :
                            <>
                              {post.othersReactionsTotal} people reacted
                            </>
                          }
                         
                        </small>
                      </div>
                    )}

          {/* Action Buttons */}
          <div className="d-flex justify-content-between border-top pt-3 px-4">
            <button
              className="btn text-muted p-0 d-flex align-items-center"
              onClick={() => handleReaction('like')}
            >
              <i className={`bi me-2 ${post.reaction === 'like' ? 'bi-hand-thumbs-up-fill' : 'bi-hand-thumbs-up'}`}></i>
              <span>Like</span>
            </button>

            <button
              className="btn text-muted p-0 d-flex align-items-center"
              onClick={() => handleReaction('love')}
            >
              <i className={`bi me-2 ${post.reaction === 'love' ? 'bi-heart-fill' : 'bi-heart'}`}></i>
              <span>Love</span>
            </button>

            <button
              className="btn text-muted p-0 d-flex align-items-center"
              onClick={() => handleReaction('appreciate')}
            >
              <i className={`bi me-2 ${post.reaction === 'appreciate' ? 'bi-emoji-smile-fill' : 'bi-emoji-smile'}`}></i>
              <span>Appreciate</span>
            </button>

            <button
              className="btn text-muted p-0 d-flex align-items-center"
              onClick={() => handleReaction('insightful')}
            >
              <i className={`bi me-2 ${post.reaction === 'insightful' ? 'bi-lightbulb-fill' : 'bi-lightbulb'}`}></i>
              <span>Insightful</span>
            </button>
          </div>
        </div>
      </div>

      {
        showModal &&
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header border-0 pb-0">
                <div className="w-100">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* <h5 className="modal-title">User Directory</h5> */}
                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                  </div>

                  {/* Filter tabs */}
                    <div className="filter-tabs d-flex gap-3 flex-wrap border-bottom">
                    {/* <button
                      className={`filter-tab ${activeFilter === "all" ? "active" : ""}`}
                      onClick={() => setActiveFilter("all")}
                      style={{backgroundColor:'unset'}}
                    >
                     
                      All {post.othersReactionsTotal}
                    </button> */}
                    <button
                      className={`filter-tab ${activeFilter === "all" ? "active" : ""}`}
                      onClick={() => setActiveFilter("all")}
                      style={{ backgroundColor: 'unset',color:'#B3A017' }}
                    >
                      {/* <i className="bi bi-list-ul me-1"></i> */}
                      <span style={{borderBottom:'1px solid'}}>
                      All {post?.othersReactionsTotal + post?.reaction ? 1 : 0}

                      </span>
                    </button>

                    <button
                      className={`filter-tab ${activeFilter === "like" ? "active" : ""}`}
                      onClick={() => setActiveFilter("like")}
                      style={{backgroundColor:'unset'}}

                    >
                      <i className="bi bi-hand-thumbs-up me-2 text-primary" ></i>
                      {post.total_like}

                    </button>

                    <button
                      className={`filter-tab ${activeFilter === "love" ? "active" : ""}`}
                      onClick={() => setActiveFilter("love")}
                      style={{backgroundColor:'unset'}}

                    >
                      <i className="bi bi-heart me-2 text-danger"></i>
                      {post.total_love}
                    </button>

                    <button
                      className={`filter-tab ${activeFilter === "appreciate" ? "active" : ""}`}
                      onClick={() => setActiveFilter("appreciate")}
                      style={{backgroundColor:'unset'}}

                    >
                      <i className="bi bi-emoji-smile me-2 text-success"></i>
                      {post.total_appreciate}
                    </button>

                    <button
                      className={`filter-tab ${activeFilter === "insightful" ? "active" : ""}`}
                      onClick={() => setActiveFilter("insightful")}
                      style={{backgroundColor:'unset'}}

                    >
                      <i className="bi bi-lightbulb me-2 text-warning"></i>
                      {post.total_insightful}
                    </button>
                  </div>

                </div>
              </div>

              <div className="modal-body pt-2">
                <div className="user-list" style={{maxHeight:'400px',overflowY:'auto'}}>
                  {post?.reaction && (
                    <div className="user-item d-flex align-items-center p-3 border-bottom bg-light">
                      <div className="user-avatar-container me-3 position-relative">
                        {user?.profileImageUrl ? (
                          <img
                            src={`${process.env.REACT_APP_BUCKET_URL}${user?.profileImageUrl}`}
                            alt={user?.fullName}
                            className="user-avatar rounded-circle"
                            style={{ width: '48px', height: '48px', objectFit: 'cover' }}
                          />
                        ) : (
                          <div
                            className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-muted fw-bold"
                            style={{ width: '48px', height: '48px', fontSize: '18px' }}
                          >
                            {getInitials(user?.fullName || 'You')}
                          </div>
                        )}
                         <span
                          className="user-badge position-absolute  rounded-circle  p-1"
                          title={post.reaction}
                          style={{bottom:'-8px', right:'2px'}}
                        >
                          <i
                            className={`bi ${{
                                like: 'bi-hand-thumbs-up-fill',
                                love: 'bi-heart-fill',
                                appreciate: 'bi-emoji-smile-fill',
                                insightful: 'bi-lightbulb-fill',
                              }[post.reaction]
                              } ${{
                                like: 'text-primary',
                                love: 'text-danger',
                                appreciate: 'text-success',
                                insightful: 'text-warning',
                              }[post.reaction]
                              }`}
                          ></i>
                        </span>
                      </div>

                      <div className="user-info">
                        <div className="user-name fw-medium">You</div>
                        <div className="user-designation text-muted small">
                          {user?.role || 'Your Role'}
                        </div>
                      </div>
                    </div>
                  )}

                  {post?.othersReactions?.map((item) => {
                    // Get icon and color based on the reaction
                    const { icon, color } = {
                      like: { icon: 'bi-hand-thumbs-up-fill', color: 'text-primary' },
                      love: { icon: 'bi-heart-fill', color: 'text-danger' },
                      appreciate: { icon: 'bi-emoji-smile-fill', color: 'text-success' },
                      insightful: { icon: 'bi-lightbulb-fill', color: 'text-warning' },
                    }[item.reaction] || {};

                    return (
                      <div key={item._id} className="user-item d-flex align-items-center p-3 border-bottom">
                        <div className="user-avatar-container me-3 position-relative">
                          {item.user?.profileImageUrl ? (
                            <img
                             src={`${process.env.REACT_APP_BUCKET_URL}${item.user.profileImageUrl}`}
                              // src={item.user.profileImageUrl}
                              alt={item.user.fullName}
                              className="user-avatar rounded-circle"
                              style={{ width: '48px', height: '48px', objectFit: 'cover' }}
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-muted fw-bold"
                              style={{ width: '48px', height: '48px', fontSize: '18px' }}
                            >
                              {getInitials(item.user?.fullName || '')}
                            </div>
                          )}

                          {icon && (
                            <span
                              className="user-badge position-absolute  rounded-circle  p-1"
                              title={item.reaction}
                              style={{bottom:'-8px', right:'2px'}}
                            >
                              <i className={`bi ${icon} ${color}`}></i>
                            </span>
                          )}
                        </div>

                        <div className="user-info ">
                          <div className="user-name fw-medium">
                            {item.user?.fullName || 'Unknown'}
                            {/* Conditionally show createdAt if you want */}
                            {/* {item.createdAt && (
                              <span className="user-time text-muted ms-1">
                                {item.createdAt}
                              </span>
                            )} */}
                          </div>
                          <div className="user-designation text-muted small">
                            {item.user?.role || 'No Role'}
                          </div>
                        </div>
                      </div>
                    );
                  })}

                </div>
              </div>
            </div>
          </div>
        </div>
      }

    </>

  );
};

export default PostCard;